export default "__VITE_ASSET__D7us8fz2__"